import React from "react";
import BlockUi from "react-block-ui";
import { JdsButton } from "../../../components/jds/JdsButton";
import { JdsTag } from "../../../components/jds/JdsTag";
import { Field, AlertIcon } from "./clienteUi";

function CardShell({ isLoading, center = false, children }) {
  return (
    <div className="col-xl-6 col-lg-6 col-md-12 mb-5">
      <BlockUi tag="div" blocking={isLoading} style={{ height: "100%" }}>
        <div
          className={`jds-card cd-product${
            center ? " cd-product--center" : ""
          }`}
        >
          {children}
        </div>
      </BlockUi>
    </div>
  );
}

export default function ServiceCard({
  isLoading,
  data,
  serviceName,
  statusMap,
  onCancel,
  isCancellable,
  onReactivate,
  isReactivatable,
  onUpgrade,
  isUpgradable,
  userId,
  headerFields,
  renewalDateField,
  extraFields
}) {
  const currentStatus = data?.cancellation?.cancelled_at
    ? "CANCELLED"
    : data?.configuration?.status;

  const status = statusMap[currentStatus] || Object.values(statusMap)[0];

  if (data?._error) {
    return (
      <CardShell isLoading={isLoading} center>
        <div className="cd-modal-icon">
          <AlertIcon />
        </div>
        <h3 className="jds-title-sm" style={{ color: "var(--fg-error-strong)" }}>
          Erro ao buscar dados
        </h3>
        <p className="text-muted mt-2 mb-0">
          Não foi possível carregar os dados do {serviceName}. Tente novamente mais tarde.
        </p>
      </CardShell>
    );
  }

  if (data?._notFound) {
    return (
      <CardShell isLoading={isLoading} center>
        <h3 className="jds-title-sm">{serviceName}</h3>
        <p className="text-muted mt-2 mb-0">
          Este cliente não possui configurações de {serviceName}.
        </p>
      </CardShell>
    );
  }

  return (
    <CardShell isLoading={isLoading}>
      <div className="cd-product-head">
        <h2 className="jds-title-md">{serviceName}</h2>
      </div>

      {headerFields &&
        headerFields.map((field, index) => (
          <p key={index} className="text-muted mb-2">
            {field}
          </p>
        ))}

      <Field label="Status">
        <JdsTag dot color={status.tone} label={status.label} />
      </Field>

      {extraFields}

      {!data?.cancellation?.cancelled_at && (
        <Field label="Data de renovação">
          {renewalDateField
            ? new Date(renewalDateField).toLocaleDateString("pt-BR")
            : "—"}
        </Field>
      )}

      <div className="cd-actions cd-actions--stretch mt-6">
        {onUpgrade && isUpgradable && (
          <JdsButton onClick={() => onUpgrade?.()}>Fazer upgrade</JdsButton>
        )}

        {/* Botão de reativação - sempre visível, desabilitado quando não é possível reativar */}
        <JdsButton
          variant="outlined"
          color="neutral"
          disabled={!isReactivatable}
          onClick={() => isReactivatable && onReactivate?.()}
        >
          Reativar
        </JdsButton>

        <JdsButton
          variant="outlined"
          color="error"
          disabled={!isCancellable}
          onClick={() => onCancel(userId)}
        >
          Cancelar
        </JdsButton>
      </div>
    </CardShell>
  );
}
